// extracted by mini-css-extract-plugin
export default {"card":"GestaoPerfis_card__A91QO","title":"GestaoPerfis_title__ecuQc","actionsHeader":"GestaoPerfis_actionsHeader__YZ4sf","sectionTitle":"GestaoPerfis_sectionTitle__aK0T7"};